// extracted by mini-css-extract-plugin
export default {"summarySection":"OrderSummary_summarySection__eEfa4"};